import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {TextField} from "@mui/material";
import {useCallback, useEffect, useRef} from "react";

const DialogBox = ({open, onClose, onAgree, title, content, agreeLabel, disagreeLabel, inputLabel}) => {

  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = ""
    }
  }, [open]);

  const handleAgree = useCallback(() => {
    onAgree(inputRef.current?.value)
  }, [inputRef, onAgree])

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>

          {inputLabel && (
            <TextField
              inputRef={inputRef}
              id="standard-multiline-static"
              label={inputLabel}
              multiline
              rows={4}
              variant="standard"
              margin="dense"
              fullWidth
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button sx={{
            color: 'red',
            borderColor: 'red',
            '&:hover': {
              backgroundColor: 'red',
              color: 'white',
            },
          }} variant="outlined" onClick={onClose}>{disagreeLabel}</Button>
          {agreeLabel && (
            <Button variant="outlined" sx={{
              color: 'green',
              borderColor: 'green',
              '&:hover': {
                backgroundColor: 'green',
                color: 'white',
              },
            }} onClick={handleAgree} autoFocus>
              {agreeLabel}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default DialogBox;
